var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.1.5@enquire.js/src/index.js
 ** module id = 441
 ** module chunks = 0 1
 **/